import React, { useContext } from 'react';

import { CircularProgressIndicatorContext } from './CircularProgressIndicatorDeterminate';
import Styled, { getStrokeWidth } from './styles';

export interface CircularProgressIndicatorBackgroundCircleProps extends React.ComponentPropsWithRef<'div'> {
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** CircularProgressIndicatorBackgroundCircle is to render the background circle of the CircularProgressIndicatorDeterminate component  */
const CircularProgressIndicatorBackgroundCircle = (props: CircularProgressIndicatorBackgroundCircleProps) => {
  const {
    theme
  } = props;
  const circularIndicatorContext = useContext(CircularProgressIndicatorContext);
  const strokeWidth = getStrokeWidth(circularIndicatorContext.circleSize);
  const circleRadius = (circularIndicatorContext.circleSize - strokeWidth) / 2;
  const centerOfTheCircle = circularIndicatorContext.circleSize / 2;

  return (
    <Styled.Circle1
      $theme={theme}
      cx={centerOfTheCircle}
      cy={centerOfTheCircle}
      r={circleRadius}
      strokeWidth={strokeWidth}
    />
  );
};

CircularProgressIndicatorBackgroundCircle.defaultProps = {
  theme: {},
};

CircularProgressIndicatorBackgroundCircle.displayName = 'CircularProgressIndicatorBackgroundCircle';

export default CircularProgressIndicatorBackgroundCircle;